<template>
  <el-dialog
    title="Request to Add Certification"
    :visible.sync="this.showModal"
    :show-close="false"
    width="550px"
    class="ts-modal"
  >
    <button
      type="button"
      aria-label="Close"
      class="el-dialog__headerbtn"
      @click="onCloseDialog(null)"
    >
      <i class="el-dialog__close el-icon el-icon-close"></i>
    </button>
    <!-- <loading 
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="false">
    </loading> -->

    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
    <div>
        <el-form>
        <p style="margin: 0px 0 20px 0 !important;">Don't see the certification you were looking for in the list? Then please send us a request with your certification details so we can add it to the list for you and for any future employees who may also have it.</p>
        <p style="margin: 0px 0 20px 0 !important;">Check back soon to see if your certification has been added.</p>
        <el-form-item label="Certification Name" required :error="retrieveFieldError(modelState, 'Description')">
            <el-input type="text" v-model="CertificateForApproval.description"> </el-input>
        </el-form-item>
      </el-form>
    </div>
    <br /><br />
    <div class="ts-app-shell--header_actions flexed">
      <button
        class="ts-btn ts-btn-small ts-btn-white"
        @click="onCloseDialog(null)"
      >
        Close
      </button>
      <button class="ts-btn ts-btn-small" @click="submitCertificate">
        Send
      </button>
    </div>
  </el-dialog>
</template>

<script>
import TSLoading from "../components/TSLoading.vue";

export default {
  components: {
    TSLoading,
  },
  name: "SubmitCertification",
  props: {
    showModal: Boolean,
  },
  data() {
    return {
      loading: false,
      NewCertificationDescription: null,
      CertificateForApproval: {},
      modelState: {},
    };
  },
  computed: {
    apiBaseUrl() {
      return process.env.VUE_APP_API_BASE_URI;
    },
  },
  methods: {
    onCloseDialog() {
      this.CertificateForApproval = {};
      this.modelState = {};
      this.$emit("close-modal");
    },
    submitCertificate() {
      this.$store
        .dispatch("sga/submitcertificate", this.CertificateForApproval)
        .then((res) => {
          this.CertificateForApproval = {};
          this.modelState = {};
          this.$confirm(
            `TalentSensus will review your certificate. If approved, we will send you a notification so you can add it to you TalentSensus profile.`,
            "Information",
            {
              confirmButtonText: "Ok",
              showCancelButton: false,
              type: "info",
              dangerouslyUseHTMLString: true,
              center: true,
            }
          ).then(() => {
            this.$message.success("New certificate successfully sent.");
            this.$emit("close-modal");
          });
        })
        .catch((res) => {
          this.modelState = res.errors;
        });
    },
  },
};
</script>
